import Swiper from 'swiper';

let viewportWidth = document.documentElement.clientWidth;
let photosArray = [];

function initPhotosSwipe() {
  $('.js-slider-photos').each(function (index) {
    if (viewportWidth < 1024 && photosArray[index] == undefined) {
      const $this = $(this);
      $this.addClass(`swph-${index}`);

      photosArray.push(new Swiper(`.swph-${index}.swiper-container`, {
        slidesPerView: 2,
        slidesPerColumn: 1,
        spaceBetween: 10,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: '.js-next-photo',
          prevEl: '.js-prev-photo',
        },
        breakpointsInverse: true,
        breakpoints: {
          768: {
            slidesPerView: 3,
            slidesPerColumn: 2,
            spaceBetween: 20
          },
        }
      }));
    } else if (viewportWidth >= 1024 && photosArray[index] != undefined) {
      photosArray[index].destroy();
      photosArray.splice(index, 1);
    }
  });
}

if ($('.js-slider-photos').length) {
  initPhotosSwipe();
}

$(window).resize(function () {
  viewportWidth = document.documentElement.clientWidth;
  setTimeout(() => {
    initPhotosSwipe();
  }, 100);
});